import React from 'react'

const PhoneIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.625 15C12.8333 15 11.0869 14.6006 9.38583 13.8017C7.68417 13.0033 6.17722 11.9478 4.865 10.635C3.55222 9.32278 2.49667 7.81583 1.69833 6.11417C0.899445 4.41306 0.5 2.66667 0.5 0.875C0.5 0.625 0.583333 0.416667 0.75 0.25C0.916667 0.0833333 1.125 0 1.375 0H4.75C4.94444 0 5.11806 0.0624999 5.27083 0.1875C5.42361 0.3125 5.51389 0.472222 5.54167 0.666667L6.08333 3.58333C6.11111 3.77778 6.10778 3.95472 6.07333 4.11417C6.03833 4.27417 5.95833 4.41667 5.83333 4.54167L3.83333 6.58333C4.41667 7.58333 5.14583 8.52083 6.02083 9.39583C6.89583 10.2708 7.86111 11.0278 8.91667 11.6667L10.875 9.70833C11 9.58333 11.1633 9.48944 11.365 9.42667C11.5661 9.36444 11.7639 9.34722 11.9583 9.375L14.8333 9.95833C15.0278 10 15.1875 10.0936 15.3125 10.2392C15.4375 10.3853 15.5 10.5556 15.5 10.75V14.125C15.5 14.375 15.4167 14.5833 15.25 14.75C15.0833 14.9167 14.875 15 14.625 15Z"
        fill="#999FAC"
      />
    </svg>
  )
}

export default PhoneIcon
